import { c as _c } from "react/compiler-runtime";
import CliLoginCommandCopyableField from '../../../../common/CliLoginCommandCopyableField';
import { CLIOnboardingContext } from '../GuidedCLIOnboarding';
interface Props {
  context: CLIOnboardingContext;
  mutateContext: (input: any) => void;
  nextStep: () => void;
  is_current_step: boolean;
}
const RunHookdeckLogin: React.FC<Props> = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CliLoginCommandCopyableField />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default RunHookdeckLogin;